import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';
import { v4 as uuidv4 } from "uuid";
import { Observable } from 'rxjs';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // throw new Error('Method not implemented.');
    let uuid = uuidv4();
    let headers = new HttpHeaders().set('Correlation-Id', uuid);
    const editedReq = req.clone({
      headers: headers,
    });
    return next.handle(editedReq);
  }
}
